var document = require('./_global').document;
module.exports = document && document.documentElement;



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/_html.js
 ** module id = 75
 ** module chunks = 2 4 5 7
 **/